export { default } from "./src/side-nav-link";

export type { UniformSideNavLinkProps } from "./src/side-nav-link";
